import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import ForgotPassword from "./app/components/ForgotPassword/views/ForgotPassword";
import PasswordResetSuccess from "./app/components/ForgotPassword/views/PasswordResetSuccess";
import ResetPassword from "./app/components/ForgotPassword/views/ResetPassword";
import VerificationCodeSent from "./app/components/ForgotPassword/views/VerificationCodeSent";
import LandingPage from "./app/components/LandingPage/views/LandingPage";
import pricing from "./app/components/pricing/views/pricing";
import PaymentCheckout from "./app/components/Payment/views/PaymentCheckout";
import SignUp from "./app/components/SignUp/views/SignUp";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import PurchaseSubscription from "./app/components/Subscription/views/PurchaseSubscription";
import Home from "./app/components/Home/views/Home";
import Dashboard from "./app/components/Dashboard/views/Dashboard";
import MyApps from "./app/components/Dashboard/views/MyApps";
import ActiveUsers from "./app/components/AdminCenter/views/ActiveUsers";
import Billing from "./app/components/AdminCenter/views/Billing.js";
import CaptureReceivedGoods from "./app/components/InventoryManagement/CaptureReceivedGoods/views/CaptureReceivedGoods";
import PrivateRoute from "./PrivateRoute ";
import Notification from "./app/components/base/views/Notification";
import EmployeeLandingPage from "./app/components/EmployeeManagement/views/EmployeeLandingPage";
import AssetLandingPage from "./app/components/AssetManagement/views/AssetLandingPage";
import SupplierLandingPage from "./app/components/Ancillary/SupplierManagement/views/SupplierLandingPage";
import RecentCaptureGoodsReport from "./app/components/Reports/views/RecentCaptureGoodsReport";
import LicenseManagementLandingPage from "./app/components/Ancillary/LicenseManagement/views/LicenseManagementLandingPage";
import AboutPage from "./app/components/About/views/About";
import OurTeam from "./app/components/Team/views/OurTeam";
// import WebsitePage from "./app/components/Website/views/Website";
import MyAccountPage from "./app/components/Dashboard/views/MyAccount";
import ReconcillationReport from "./app/components/Reports/views/ReconcillationReport";
import SaleableReturn from "./app/components/InventoryManagement/SaleableReturn/views/SaleableReturn";
import NonSaleableReturnLandingPage from "./app/components/InventoryManagement/NonSaleableReturn/views/NonSaleableReturnLandingPage";
import AnalyticsDashboard from "./app/components/Analytics/Dashboard/views/AnalyticsDashboard";
import { signOut } from "./app/components/signin/helper/signInHelper";
import SaleableReturnReconcilationReport from "./app/components/Reports/views/SaleableReturnReconcilationReport";
import MyStore from "./app/components/Dashboard/views/MyStore";
import PhysicalInventoryLandingPageWithLotNo from "./app/components/InventoryManagement/PhysicalInventory/views/PhysicalInventoryLandingPageWithLotNo";
import MasterProduct from "./app/components/MasterProduct/views/MasterProduct";
import PhysicalInventoryReport from "./app/components/Reports/views/PhysicalInventoryReport";
import AimsChatBot from "./app/components/AimsChatBot/views/AimsChatBot";
import PhysicalInventoryLandingPageWithoutLotNo from "./app/components/InventoryManagement/PhysicalInventory/views/PhysicalInventoryLandingPageWithoutLotNo";
import PhysicalInventoryReportWithoutLotNo from "./app/components/Reports/views/PhysicalInventoryReportWithoutLotNo";
import PhysicalInventoryLandingPage from "./app/components/InventoryManagement/PhysicalInventory/views/PhysicalInventoryLandingPage";
import PhysicalInventoryCostReport from "./app/components/Reports/PICostReport/PhysicalInventoryCostReport.js";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(0, 0, 0, 0.9);",
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "rgb(255, 255, 255)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left center",
          backgroundAttachment: "fixed",
          height: "auto",
          width: "auto",
        },
      },
    },
  },
});

function Routes() {
  useEffect(() => {
    window.addEventListener("beforeunload", () => {
      signOut();
    });
    return () => window.removeEventListener("beforeunload", () => {});
  });

  return (
    <MuiThemeProvider theme={theme}>
      <Notification />
      <Switch>
        <React.Fragment>
          <PrivateRoute path="/" component={AimsChatBot} />
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/signIn" component={LandingPage} />
          <Route exact path="/signUp" component={SignUp} />
          <Route exact path="/forgotPassword" component={ForgotPassword} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/ourTeam" component={OurTeam} />
          <Route exact path="/resetPassword" component={ResetPassword} />
          <PrivateRoute
            exact
            path="/verificationCodeSent"
            component={VerificationCodeSent}
          />
          <PrivateRoute
            exact
            path="/passwordResetSuccess"
            component={PasswordResetSuccess}
          />
          <PrivateRoute
            exact
            path="/paymentCheckout"
            component={PaymentCheckout}
          />
          <Route exact path="/pricing" component={pricing} />
          <PrivateRoute
            exact
            path="/purchaseSubscription"
            component={PurchaseSubscription}
          />
          {/* dashboard -> home and home -> dashboard */}
          <PrivateRoute exact path="/dashboard" component={Home} />
          <PrivateRoute exact path="/home" component={Dashboard} />
          <PrivateRoute exact path="/apps" component={MyApps} />
          <PrivateRoute exact path="/activeUsers" component={ActiveUsers} />
          <PrivateRoute exact path="/billing" component={Billing} />
          <PrivateRoute
            exact
            path="/captureReceivedGoods"
            component={CaptureReceivedGoods}
          />
          <PrivateRoute exact path="/signOut" component={LandingPage} />
          <PrivateRoute
            exact
            path="/employeeManagement"
            component={EmployeeLandingPage}
          />
          <PrivateRoute
            exact
            path="/masterProductManagement"
            component={MasterProduct}
          />
          <PrivateRoute
            exact
            path="/assetManagement"
            component={AssetLandingPage}
          />
          <PrivateRoute
            exact
            path="/ancillary/supplierManagement"
            component={SupplierLandingPage}
          />
          <PrivateRoute exact path="/uploads" component={AnalyticsDashboard} />
          <PrivateRoute
            exact
            path="/reports/recentCapturedGoodsReport"
            component={RecentCaptureGoodsReport}
          />
          <PrivateRoute
            exact
            path="/reports/reconcillationReport"
            component={ReconcillationReport}
          />
          <PrivateRoute
            exact
            path="/ancillary/licenseManagement"
            component={LicenseManagementLandingPage}
          />
          <PrivateRoute exact path="/myAccount" component={MyAccountPage} />
          <PrivateRoute exact path="/myStore" component={MyStore} />
          <PrivateRoute
            exact
            path="/masterProducts"
            component={MasterProduct}
          />

          <PrivateRoute
            exact
            path="/inventory/saleableReturn"
            component={SaleableReturn}
          />
          <PrivateRoute
            exact
            path="/reports/saleableReturnReconcillationReport"
            component={SaleableReturnReconcilationReport}
          />
          <PrivateRoute
            exact
            path="/reports/physicalInventoryReport"
            component={PhysicalInventoryReport}
          />
          <PrivateRoute
            exact
            path="/reports/physicalInventoryCostReport"
            component={PhysicalInventoryCostReport}
          />
          <PrivateRoute
            exact
            path="/inventory/nonsaleableReturn"
            component={NonSaleableReturnLandingPage}
          />
          <PrivateRoute
            exact
            path="/physicalInventory"
            component={PhysicalInventoryLandingPage}
          />
          <PrivateRoute
            exact
            path="/inventory/physicalInventorywithlotno"
            component={PhysicalInventoryLandingPageWithLotNo}
          />
          <PrivateRoute
            exact
            path="/inventory/physicalInventorywithoutlotno"
            component={PhysicalInventoryLandingPageWithoutLotNo}
          />
          <PrivateRoute
            exact
            path="/inventory/physicalInventoryReportWithoutLotNo"
            component={PhysicalInventoryReportWithoutLotNo}
          />
        </React.Fragment>
      </Switch>
    </MuiThemeProvider>
  );
}

export default Routes;
